/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import { Box, Stack } from '@mui/material';
import type { UINotification } from '@poweralpha/common';
import { useMemo } from 'react';
import { groupNotificationsByDay } from '../display';
import NotificationRow from './NotificationRow';
import { dayHeaderSx } from './styles';

interface Props {
  notifications: Array<UINotification>;
  selectedId?: string;
  onSelect: (notification: UINotification) => void;
  onMarkRead?: (notification: UINotification) => void;
}

/** Notifications grouped under Today / Yesterday / weekday / date headers. */
function NotificationList({ notifications, selectedId, onSelect, onMarkRead }: Readonly<Props>) {
  const groups = useMemo(() => groupNotificationsByDay(notifications), [notifications]);

  return (
    <Stack component="ul" spacing={0.25} sx={{ m: 0, p: 0, listStyle: 'none' }}>
      {groups.map(({ key, label, notifications: dayNotifications }) => (
        <Box component="li" key={key}>
          <Box sx={dayHeaderSx}>{label}</Box>
          <Stack spacing={0.25}>
            {dayNotifications.map((notification) => (
              <NotificationRow
                key={notification.id}
                notification={notification}
                selected={notification.id === selectedId}
                onSelect={onSelect}
                onMarkRead={onMarkRead}
              />
            ))}
          </Stack>
        </Box>
      ))}
    </Stack>
  );
}

export default NotificationList;
